import { usePermissions } from '../../../hooks/usePermissions';
import {
  FUEL_SURCHARGE_OVERRIDE_PERMISSION,
  HIRED_EQUIPMENT_FINANCIALS_PERMISSION,
} from '../utils/fieldVisibility';

/**
 * Shared HE-F17 / HE-F18 check.
 *
 * M22: the Fuel column is shown (read-only) to everyone who can see HE lines, so every line
 * reconciles – Qty × Rate + Fuel = Amount. Fuel is no more sensitive than Rate, which was already
 * visible, so no new permission is needed and Supervisors keep their current role. Editing the
 * fuel override still needs fuel:custom_surcharge_override.
 */
export function useHiredEquipmentFieldVisibility(): {
  showFinancials: boolean;
  showFuel: boolean;
  canOverrideFuel: boolean;
  loading: boolean;
} {
  const { hasPermission, loading } = usePermissions();
  return {
    showFinancials: hasPermission(HIRED_EQUIPMENT_FINANCIALS_PERMISSION),
    showFuel: true,
    canOverrideFuel: hasPermission(FUEL_SURCHARGE_OVERRIDE_PERMISSION),
    loading,
  };
}
